export default function dynamicFields() {
    // Finde alle Feldgruppen
    const fieldGroups = document.querySelectorAll('.js-dynamic-field-group');

    fieldGroups.forEach((group) => {
        // Hole alle dynamischen Felder in DOM-Reihenfolge
        const fields = Array.from(group.querySelectorAll('.js-dynamic-field'));

        if (fields.length < 2) {
            // Mindestens 2 Felder für dynamisches Verhalten nötig
            return;
        }

        // Helper: Finde Input-Element innerhalb des Containers
        function getInputElement(container) {
            return container.querySelector('input, textarea, select');
        }

        // Helper: Prüfe ob Feld einen Wert hat
        function hasValue(container) {
            const input = getInputElement(container);
            return input && input.value.trim().length > 0;
        }

        // Flag um Endlosschleifen zu verhindern
        let isUpdating = false;

        // Update Sichtbarkeit basierend auf Vorgänger
        function updateFieldVisibility() {
            // Verhindere rekursive Aufrufe
            if (isUpdating) return;
            isUpdating = true;

            fields.forEach((field, index) => {
                if (index === 0) {
                    // Erstes Feld immer sichtbar
                    return;
                }

                // Prüfe das vorherige Feld
                const previousField = fields[index - 1];
                const shouldBeVisible = hasValue(previousField);

                if (shouldBeVisible) {
                    field.classList.remove('hidden');
                } else {
                    // Verstecke dieses und alle nachfolgenden Felder
                    for (let i = index; i < fields.length; i += 1) {
                        fields[i].classList.add('hidden');
                        const input = getInputElement(fields[i]);
                        if (input && input.value !== '') {
                            /* eslint-disable-next-line no-param-reassign */
                            input.value = '';
                            // Entferne das Event-Dispatching komplett um Stack Overflow zu vermeiden
                        }
                    }
                }
            });

            // Reset flag
            isUpdating = false;
        }

        // Initiale Sichtbarkeit setzen
        updateFieldVisibility();

        // Event Listener für alle Input-Felder
        fields.forEach((field) => {
            const input = getInputElement(field);
            if (input) {
                // Debounce für bessere Performance
                let timeout;
                const debouncedUpdate = () => {
                    clearTimeout(timeout);
                    timeout = setTimeout(updateFieldVisibility, 150);
                };

                input.addEventListener('input', debouncedUpdate);
                input.addEventListener('change', updateFieldVisibility);
            }
        });
    });
}

// Initialisierung wird jetzt in main.js durchgeführt
// window.addEventListener('load', dynamicFields);

// Export für manuellen Aufruf nach AJAX
export function reinitializeDynamicFields() {
    dynamicFields();
}
